/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   types.ts
 */
import type { RangeSelectorOption } from '@zcode-ui/controls'
import type { NonEmptyEngrainMap, RawMedia, Unit } from '@zcode/bizos'
import type { FloorplanListing, NormalFloorplanListingData } from '@zcode/state-type'
import type { CamelCaseKeys } from 'camelcase-keys'

export interface MessageBarProps {
  selectedFloorplan?: FloorplanListing<NormalFloorplanListingData>
}

export const PAGE_KEYS = {
  PAGE_MAP: 'PAGE_MAP',
  PAGE_FLOORPLAN: 'PAGE_FLOORPLAN',
} as const

export interface FullUnitObject {
  bathrooms: number
  bedrooms: number
  engrainFloorId: string
  engrainUnitId: string
  engrainUnitNumber: string
  maxPrice: number
  minPrice: number
  squareFeet: number
  zumperListingId: number
  zumperUnitId: number
  media: Array<CamelCaseKeys<RawMedia, true>>
  buildingAmenities: number[]
  amenities: number[]
}
export interface EngrainFilterValuesRoot {
  priceRange?: number[]
  bedrooms: RangeSelectorOption[]
}

export interface EngrainFilterValuesTemp {
  priceRange?: number[]
  bedrooms: RangeSelectorOption[]
}

export interface EngrainValuesRoot {
  readonly rootFilters: EngrainFilterValuesRoot
  readonly tempFilters: EngrainFilterValuesTemp
  readonly selectedUnits: FullUnitObject[]
  readonly selectedFloor?: string // doesnt exist until api response
  readonly pageKey: keyof typeof PAGE_KEYS
  readonly selectedPageUnit?: FullUnitObject
  readonly engrainMap?: NonEmptyEngrainMap
  readonly engrainMapMeta: {
    error?: string
    fetching?: boolean
    fetchingKey?: number
    currentKey?: number
  }
  readonly units?: Unit[] | undefined
  readonly unitsMeta: {
    error?: string
    fetching?: boolean
    fetchingKey?: number
    currentKey?: number
  }
}
